import {PollOptions} from "@/types/PollOptions.ts";

export enum PollStatus{
    draft = 0,
    active = 1 ,
    pending = 2,
    completed = 3,
    inactive = 4,
}
interface Summary{
    pollId: string;
    pollTitle: string;
    optionId: string;
    optionTitle: string;
    percentage: number;
}

export interface Poll {
    id: string;
    title: string;
    options: PollOptions[];
    prize: number;
    entryFee: number;
    createdAt: Date;
    endDate: Date;
    createdBy: string;
    status: PollStatus;
    categoryId: string;
    imageUrl: string;
    isFeatured: boolean;
    totalVotes: number;
    categories: { slug: string};
    hint?: string;
    slug?: string;
    viewCount?: number;
    resolvedAt?: Date;
    userVotes?: [{
        id: string,
        poll_id: string,
        option_id: string,
    }];
    isTop?: boolean;
    summary?: Summary[]
}
